import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';

import { FieldType } from '@ngx-formly/core';

import { ITaFormlyOptions } from '@models/types';
import { AuditService } from '@services/audit.service';

import { set, unset } from 'lodash-es';

const TAG = 'TaRadioComponent';

@Component({
    selector: 'app-ta-radio',
    templateUrl: './ta-radio.html',
    styleUrls: ['./ta-radio.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class TaRadioComponent extends FieldType implements OnInit {

    public defaultOptions = {
        templateOptions: { options: [] },
    };
    private failPath: string;
    private updatedKey: string;
    public icons: Record<number, { checked: string; unchecked: string }> = {
        0: { checked: 'checkmark-circle', unchecked: 'checkmark-circle-outline' },
        1: { checked: 'close-circle', unchecked: 'close-circle-outline' },
        2: { checked: 'remove-circle', unchecked: 'remove-circle-outline' }
    };

    constructor(
        private auditService: AuditService,
        public toastController: ToastController
    ) {
        super();
    }

    @HostListener('ionBlur')
    public ionBlur() {
        const METHOD = 'ionBlur';
        console.log(TAG + METHOD, this.updatedKey);
    }

    @HostListener('ionChange')
    public async ionChange() {
        const METHOD = 'ionChange';
        console.log(TAG + METHOD, this.updatedKey);
        await this.checkOptionChanges();
    }

    @HostListener('ionFocus')
    public ionFocus() {
        const METHOD = 'ionFocus';
        console.log(TAG + METHOD, this.updatedKey);
    }

    async ngOnInit() {
        // Get the failPath of the field by replacing the ".value" field's key with ".failed"
        this.updatedKey = this.key as string;
        if (this.field.parent?.key && this.field.parent?.parent.key) {
            this.updatedKey = this.field.parent?.parent.key + '[' + this.field.parent?.key + '].' + this.key;
        }

        this.failPath = (this.key as string).substring(0, (this.key as string).lastIndexOf('.')) + '.failed';

        for (const option of (this.props.options as ITaFormlyOptions[])) {
            if (option.disabled) {
                this.formControl.get(option.key).disable();
            }

        }
    }

    public clear() {
        // The formControl.reset triggers an ionChange event with a null formControl.value
        this.formControl.reset(null);
    }

    private async checkOptionChanges() {
        if (this.formControl.value) {
            const options = this.props.options as ITaFormlyOptions[];
            let answer: string;
            for (const option of options) {
                if (option.key === this.formControl.value) {
                    answer = option.value;
                    if (option.failedResponse) {
                        set(this.model, this.failPath, option.severity);
                    } else {
                        set(this.model, this.failPath, null);
                    }
                }
            }
            this.auditService.setLocationAndTimestamp(this.updatedKey);
        } else {
            unset(this.model, this.failPath);
            this.auditService.unsetLocationAndTimestamp(this.updatedKey);
        }
    }

}
